import React, { useState, useEffect } from 'react';

// Image paths for all box attributes
const imagePaths = {
    boxColor: {
      'Yellow': 'box_yellow_s.jpg',
      'Red': 'box_red_s.jpg',
      'Orange': 'box_orange_s.jpg',
      'Blue': 'box_blue_s.jpg',
      'Light blue': 'box_lightblue_s.jpg',
      'Green': 'box_green_s.jpg',
      'Light green': 'box_lightgreen_s.jpg',
      'Grey': 'box_grey_s.jpg',
      'Black': 'box_black_s.jpg',
      'White': 'box_white_s.jpg',
    },
    inlayType: {
      23: 'box_inlay_23_s.jpg',
      24: 'box_inlay_24_s.jpg', 
      25: 'box_inlay_25_s.jpg', 
      34: 'box_inlay_34_s.jpg',
      35: 'box_inlay_35_s.jpg', 
      36: 'box_inlay_36_s.jpg', 
      37: 'box_inlay_37_s.jpg', 
    },
    velvetColor: {
      'Green': 'box_velvet_green_s.jpg',
      'Black': 'box_velvet_black_s.jpg',
      'Red': 'box_velvet_red_s.jpg',
      'White': 'box_velvet_white_s.jpg'
    }
};

const inlayTypes = {
  Small: [23, 24, 25],
  Large: [34, 35, 36, 37],
};
  
const Box = ({ onAddItem }) => {
  const [boxType, setBoxType] = useState('Small');
  const [boxColor, setBoxColor] = useState('Yellow');
  const [lidColor, setLidColor] = useState('Yellow');
  const [customLidText, setCustomLidText] = useState(false);
  const [lidText, setLidText] = useState('Turtle');
  const [lidTextColor, setLidTextColor] = useState('Black');
  const [inlayColor, setInlayColor] = useState('Yellow');
  const [inlayType, setInlayType] = useState(25);
  const [availableInlayTypes, setAvailableInlayTypes] = useState([]);
  const [velvetColor, setVelvetColor] = useState('Green');
  const [isExampleVisible, setIsExampleVisible] = useState(false);

  const boxTypeOptions = [
    { value: 'Small', label: 'Small' },
    { value: 'Large', label: 'Large' },
  ];
  const boxColorOptions = [
    { value: 'Yellow', label: 'Yellow' },
    { value: 'Red', label: 'Red' },
    { value: 'Orange', label: 'Orange' },
    { value: 'Blue', label: 'Blue' },
    { value: 'Light blue', label: 'Light blue' },
    { value: 'Green', label: 'Green' },
    { value: 'Light green', label: 'Light green' },
    { value: 'Grey', label: 'Grey' },
    { value: 'Black', label: 'Black' },
    { value: 'White', label: 'White' },
  ];
  const velvetColorOptions = [
    { value: 'Green', label: 'Green' },
    { value: 'Black', label: 'Black' },
    { value: 'Red', label: 'Red' },
    { value: 'White', label: 'White' },
  ];

  // Effect to update and set the default inlay type whenever boxType changes
  useEffect(() => {
    const availableInlayTypes = inlayTypes[boxType];
    setAvailableInlayTypes(availableInlayTypes);
    const lastOption = availableInlayTypes[availableInlayTypes.length - 1];
    setInlayType(lastOption);
  }, [boxType]);

  // Show the box example when the user clicks on any of the information symbols
  const toggleExampleVisibility = () => setIsExampleVisible(prevVisible => !prevVisible);
  // Style for the info symbol
  const infoSymbolStyle = {
    cursor: 'pointer',
    marginLeft: '8px',
    color: '#007bff',
    fontWeight: 'bold',
    fontFamily: 'sans-serif'
  };

  // --- Style objects for cleaner JSX ---
  const containerStyle = {
    display: 'flex',
    flexDirection: 'row',
    gap: '20px'
  };

  const columnStyle = {
    flex: 1,
    padding: '10px'
  };
  
  const imageColumnStyle = {
    flex: 1,
    padding: '10px',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'flex-start',
    visibility: isExampleVisible ? 'visible' : 'hidden',
    transition: 'visibility 0.2s linear'
  };

  const imageStyle = {
    maxWidth: '100%',
    height: 'auto',
    border: '1px solid #ccc'
  };

  return (
    <div>
      <label htmlFor="quantity">Quantity:</label><br />
      <input type="number" id="quantity" min="1" defaultValue="1" /><br /><br />

      {/* *** MAIN TWO-COLUMN CONTAINER *** */}
      <div style={containerStyle}>
      
        {/* --- LEFT COLUMN (OPTIONS) --- */}
        <div style={columnStyle} className="selection box-selection"> 
          <div>
            <label htmlFor="boxType">Box type:</label>
            <span onClick={toggleExampleVisibility} style={infoSymbolStyle} title="Toggle example">ℹ️</span>
            <br />
            <select id="boxType" value={boxType} onChange={e => setBoxType(e.target.value)}>
              {boxTypeOptions.map(option => (
                <option key={option.value} value={option.value}>{option.label}</option>
              ))}
            </select>
          </div>
          <br/>
        
          <div>
            <label htmlFor="boxColor">Box colour:</label><br />
            <select id="boxColor" value={boxColor} onChange={e => setBoxColor(e.target.value)}>
              {boxColorOptions.map(option => (
                <option key={option.value} value={option.value}>{option.label}</option>
              ))}
            </select>
            {/* Display the image based on the selected color */}
            {boxColor && (
              <span><img src={imagePaths.boxColor[boxColor]} alt={`Box in ${boxColor}`} /></span>
            )}
          </div>
          <br/>

          <div>
            <label htmlFor="lidColor">Lid colour:</label><br />
            <select id="lidColor" value={lidColor} onChange={e => setLidColor(e.target.value)}>
              {boxColorOptions.map(option => (
                <option key={option.value} value={option.value}>{option.label}</option>
              ))}
            </select>
            {/* Display the image based on the selected color */}
            {lidColor && (
              <span><img src={imagePaths.boxColor[lidColor]} alt={`Lid in ${lidColor}`} /></span>
            )}
          </div>
          <br/>

          <div className="lidtext-container">
            <label htmlFor="customLidText">
              <input type="checkbox" id="customLidText" checked={customLidText} onChange={e => setCustomLidText(e.target.checked)} />
              Add text on Lid
            </label>
            <br/>

            {customLidText && (
              <>
                <div>
                  <label htmlFor="lidTextColor">Lid text colour:</label><br />
                  <select id="lidTextColor" value={lidTextColor} onChange={e => setLidTextColor(e.target.value)}>
                    {boxColorOptions.map(option => (
                      <option key={option.value} value={option.value}>{option.label}</option>
                    ))}
                  </select>
                </div>
                <br/>
        
                <label htmlFor="lidText">Text on Lid:</label><br />
                <textarea id="lidText" value={lidText} onChange={e => setLidText(e.target.value)} />
                <br />
              </>
            )}
          </div>
          <br/>

          <div>
            <label htmlFor="inlayType">Inlay type:</label><br />
            <select id="inlayType" value={inlayType} onChange={e => setInlayType(e.target.value)}>
              {availableInlayTypes.map((type) => (
                <option key={type} value={type}>{type} figures</option>
              ))}
            </select>
            {/* Display the image based on the selected type */}
            {inlayType && (
              <span><img src={imagePaths.inlayType[inlayType]} alt={`Inlay with ${inlayType} figures`} /></span>
            )}
          </div>
          <br/>

          <div>
            <label htmlFor="inlayColor">Inlay colour:</label><br />
            <select id="inlayColor" value={inlayColor} onChange={e => setInlayColor(e.target.value)}>
              {boxColorOptions.map(option => (
                <option key={option.value} value={option.value}>{option.label}</option>
              ))}
            </select>
            {/* Display the image based on the selected color */}
            {inlayColor && (
              <span><img src={imagePaths.boxColor[inlayColor]} alt={`Inlay in ${inlayColor}`} /></span>
            )}
          </div>
          <br/>

          <div>
            <label htmlFor="velvetColor">Velvet colour:</label><br />
            <select id="velvetColor" value={velvetColor} onChange={e => setVelvetColor(e.target.value)}>
              {velvetColorOptions.map(option => (
                <option key={option.value} value={option.value}>{option.label}</option>
              ))}
            </select>
            {/* Display the image based on the selected color */}
            {velvetColor && (
              <span><img src={imagePaths.velvetColor[velvetColor]} alt={`Velvet in ${velvetColor}`} /></span>
            )}
          </div>
          <br/>
        </div>

        {/* --- RIGHT COLUMN (IMAGE) --- */}
        <div style={imageColumnStyle}>
          <h4>Example:</h4>
          <img src="box_example.jpg" alt="Example of the box" style={imageStyle} />
        </div>

      </div>
      <br />

      <button onClick={() => 
        onAddItem({ 
          quantity: parseInt(document.getElementById('quantity').value) || 1, 
          boxType,
          boxColor, 
          lidColor,
          customLidText,
          lidText,
          lidTextColor,
          inlayColor,
          inlayType,
          velvetColor
        }) 
      }>
        Add to Cart
      </button>
    </div>
  );
};

export default Box;